import React from 'react';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

const theme = createTheme({
    direction: "rtl",
    typography: {
        "fontFamily": "IRANSans",
        "fontSize": 14,
        "fontWeightLight": 300,
        "fontWeightRegular": 400,
        "fontWeightMedium": 500
    }
    // color:{
    //     inputBackground:'#f0f0f0',
    //     inputIconColor:'#adadad',
    //     buttonBackground:'#ec0a9a',
    //     buttonColor:'#fefffd',
    //     navbarBackground: 'rgb(156,0,143) !important',
    //     navbarGradient: 'linear-gradient(90deg, rgba(156,0,143,1) 0%, rgba(255,0,162,1) 100%) !important'
    // },

});
export default function RTL(props: any) {
    return (

        <ThemeProvider theme={theme}>
            {props.children}
        </ThemeProvider>

    );
}